import { render, staticRenderFns } from "./LmProcessTypesNewOrEdit.vue?vue&type=template&id=38f7890a&scoped=true&"
import script from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessTypesNewOrEdit.vue?vue&type=style&index=0&id=38f7890a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7890a",
  null
  
)

export default component.exports